/**
 * Kinetipath FAQ — Client-side search filter.
 *
 * Filters faq-category accordion items by question + answer text on
 * every keystroke. Preserves accordion [open] state across filter
 * operations: search uses the [hidden] attribute, not [open], so a Q
 * the user expanded before searching stays expanded after clearing.
 *
 * Hides categories whose every question is hidden. Shows an empty-state
 * message when all categories are hidden AND a query is active.
 *
 * Initialised on DOMContentLoaded. Bails silently if the search section
 * is not on the current page.
 */
(function () {
  'use strict';

  function init() {
    var input = document.querySelector('[data-faq-search-input]');
    if (!input) return;

    var clear = document.querySelector('[data-faq-search-clear]');
    var empty = document.querySelector('[data-faq-search-empty]');
    var questions = document.querySelectorAll('[data-faq-question]');
    var categories = document.querySelectorAll('[data-faq-category]');

    if (!questions.length) return;

    // Pre-index each question's full searchable text (question + answer textContent).
    // Avoids re-traversing the DOM on every keystroke.
    var index = new Map();
    for (var i = 0; i < questions.length; i++) {
      var q = questions[i];
      var summary = q.querySelector('summary');
      var answer = q.querySelector('[data-faq-answer]');
      var qText = summary ? summary.textContent : '';
      var aText = answer ? answer.textContent : '';
      index.set(q, (qText + ' ' + aText).toLowerCase());
    }

    var lastQuery = null;

    function apply(query) {
      query = (query || '').trim().toLowerCase();
      if (query === lastQuery) return;
      lastQuery = query;

      // Toggle question visibility via .hidden — preserves [open] state.
      index.forEach(function (haystack, q) {
        var match = query === '' || haystack.indexOf(query) !== -1;
        q.hidden = !match;
      });

      // Toggle category visibility — hide if all questions inside are hidden.
      for (var c = 0; c < categories.length; c++) {
        var cat = categories[c];
        var qs = cat.querySelectorAll('[data-faq-question]');
        var anyVisible = false;
        for (var j = 0; j < qs.length; j++) {
          if (!qs[j].hidden) { anyVisible = true; break; }
        }
        cat.hidden = !anyVisible;
      }

      // Empty state — only when nothing matches AND a query is active.
      if (empty) {
        var allHidden = true;
        for (var k = 0; k < categories.length; k++) {
          if (!categories[k].hidden) { allHidden = false; break; }
        }
        empty.hidden = !(allHidden && query !== '');
      }

      if (clear) clear.hidden = query === '';
    }

    var timer = null;
    input.addEventListener('input', function (e) {
      if (timer) clearTimeout(timer);
      var value = e.target.value;
      timer = setTimeout(function () { apply(value); }, 120);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value !== '') {
        input.value = '';
        if (timer) clearTimeout(timer);
        apply('');
      }
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        if (timer) clearTimeout(timer);
        apply('');
        input.focus();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
